<template>
  <div>Usted esta siendo redirijido...</div>
</template>
<script>
export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    loginError() {
      return this.$store.state.error;
    },
  },
  watch: {
    user(val) {
      if (val) {
        this.$router.replace(this.$router.history.current.query.from);
      }
    },
    loginError(val) {
      if (val) {
        this.$router.replace("/login");
      }
    },
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.replace("/login");
    } else {
      this.$store.dispatch("GET_ME");
      // this.$store.dispatch("listTrackings");
    }
  },
};
</script>